"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormat = void 0;
var NumberFormatType_1 = require("./NumberFormatType");
var Constant_1 = require("../utils/Constant");
var NumberFormatFactory_1 = __importDefault(require("./NumberFormatFactory"));
var FormatUtils_1 = require("../utils/FormatUtils");
var NumberFormat = /** @class */ (function () {
    function NumberFormat(options) {
        if (options.id === 0 || options.pattern === Constant_1.DEFAULT_FORMAT_PATTERN) {
            this._type = NumberFormatType_1.NUMBER_FORMAT_TYPE.GENERAL;
        }
        this._type = null;
        this._id = options.id || null;
        this._pattern = options.pattern || null;
    }
    /**
     * 享元类的规范 newInstance 方法
     * @param options
     */
    NumberFormat.newInstance = function (options) {
        return NumberFormatFactory_1.default.createInstance(options);
    };
    NumberFormat.serialize = function (numberFormat, options) {
        if (options === void 0) { options = {}; }
        if (!options.simpleSerialize) {
            // 序列化id和pattern
            return [
                [0, 1],
                [numberFormat.id, numberFormat.pattern],
            ];
        }
        // 仅序列化id
        return [[0], [numberFormat.id]];
    };
    NumberFormat.deserialize = function (data) {
        return NumberFormatFactory_1.default.createInstance({
            id: data[1][0],
            pattern: data[1][1],
        });
    };
    NumberFormat.prototype.getOptions = function () {
        return {
            id: this.id,
            pattern: this.pattern,
        };
    };
    Object.defineProperty(NumberFormat.prototype, "id", {
        get: function () {
            return this._id || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumberFormat.prototype, "pattern", {
        get: function () {
            return this._pattern || Constant_1.DEFAULT_FORMAT_PATTERN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumberFormat.prototype, "type", {
        get: function () {
            if (!this._type) {
                var cellType = FormatUtils_1.getCellNumberFormatType(this.pattern);
                this._type = cellType.group;
            }
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumberFormat.prototype, "_key", {
        get: function () {
            return "N" + this.toString();
        },
        enumerable: false,
        configurable: true
    });
    NumberFormat.prototype.serialize = function (options) {
        if (options === void 0) { options = {}; }
        if (!options.simpleSerialize) {
            return [this.id, this.pattern];
        }
        return [this.id];
    };
    /**
     * equal
     * @param numberFormat
     */
    NumberFormat.prototype.equals = function (numberFormat) {
        return this.id === numberFormat.id && this.type === numberFormat.type && this.pattern === numberFormat.pattern;
    };
    /**
     * 克隆
     */
    NumberFormat.prototype.clone = function () {
        return this;
    };
    /**
     * 索引会用到toString
     */
    NumberFormat.prototype.toString = function () {
        return "{" + this.id + "," + this.pattern + "}";
    };
    return NumberFormat;
}());
exports.NumberFormat = NumberFormat;
//# sourceMappingURL=NumberFormat.js.map